import { css } from '@/styled-system/css';

export const switchInputStyles = css.raw({ srOnly: true });
